const LOGIN_REQUEST = "LOGIN_REQUEST";
const LOGIN_SUCCESS = "LOGIN_SUCCESS";
const LOGIN_FAILURE = "LOGIN_FAILURE";

const LOGO_REQUEST = "LOGO_REQUEST";
const LOGO_SUCCESS = "LOGO_SUCCESS";
const LOGO_FAILURE = "LOGO_FAILURE";

const CLEAR_LOGIN_ERROR = "CLEAR_LOGIN_ERROR";

const FORGOT_REQUEST = "FORGOT_REQUEST";
const FORGOT_SUCCESS = "FORGOT_SUCCESS";
const FORGOT_FAILURE = "FORGOT_FAILURE";

const RESET_REQUEST = "RESET_REQUEST"; 
const RESET_SUCCESS = "RESET_SUCCESS"; 
const RESET_FAILURE = "RESET_FAILURE";  

const LOGOUT_REQUEST = "LOGOUT_REQUEST";
const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
const LOGOUT_FAILURE = "LOGOUT_FAILURE";
const FORCE_LOGOUT = "FORCE_LOGOUT";

const SIDEBAR_LINKS_REQUEST = "SIDEBAR_LINKS_REQUEST";
const SIDEBAR_LINKS_SUCCESS = "SIDEBAR_LINKS_SUCCESS";
const SIDEBAR_LINKS_FAILURE = "SIDEBAR_LINKS_FAILURE";

const DASHBOARD_REQUEST = "DASHBOARD_REQUEST";
const DASHBOARD_SUCCESS = "DASHBOARD_SUCCESS";
const DASHBOARD_FAILURE = "DASHBOARD_FAILURE";

const GET_DASHLET_REQUEST = "GET_DASHLET_REQUEST";
const GET_DASHLET_SUCCESS = "GET_DASHLET_SUCCESS";
const GET_DASHLET_FAILURE = "GET_DASHLET_FAILURE";

const ADD_DASHLET_REQUEST = "ADD_DASHLET_REQUEST";
const ADD_DASHLET_SUCCESS = "ADD_DASHLET_SUCCESS";
const ADD_DASHLET_FAILURE = "ADD_DASHLET_FAILURE";

const EDIT_DASHLET_REQUEST = "EDIT_DASHLET_REQUEST";
const EDIT_DASHLET_SUCCESS = "EDIT_DASHLET_SUCCESS";
const EDIT_DASHLET_FAILURE = "EDIT_DASHLET_FAILURE";

const CONFIGURE_DASHLET_REQUEST = "CONFIGURE_DASHLET_REQUEST";
const CONFIGURE_DASHLET_SUCCESS = "CONFIGURE_DASHLET_SUCCESS";
const CONFIGURE_DASHLET_FAILURE = "CONFIGURE_DASHLET_FAILURE";

const STORE_STATE_REQUEST = "STORE_STATE_REQUEST";
const STORE_STATE_SUCCESS = "STORE_STATE_SUCCESS";
const STORE_STATE_FAILURE = "STORE_STATE_FAILURE";

const ADD_DASHBOARD_REQUEST = "ADD_DASHBOARD_REQUEST";
const ADD_DASHBOARD_SUCCESS = "ADD_DASHBOARD_SUCCESS";
const ADD_DASHBOARD_FAILURE = "ADD_DASHBOARD_FAILURE";

const USER_PREFERENCE_REQUEST = 'USER_PREFERENCE_REQUEST';
const USER_PREFERENCE_SUCCESS = 'USER_PREFERENCE_SUCCESS';
const USER_PREFERENCE_FAILURE = 'USER_PREFERENCE_FAILURE';

const FILTER_CONFIG_REQUEST = "FILTER_CONFIG_REQUEST";
const FILTER_CONFIG_SUCCESS = "FILTER_CONFIG_SUCCESS";
const FILTER_CONFIG_FAILURE = "FILTER_CONFIG_FAILURE";

const LIST_VIEW_REQUEST = "LIST_VIEW_REQUEST";
const LIST_VIEW_SUCCESS = "LIST_VIEW_SUCCESS";
const LIST_VIEW_FAILURE = "LIST_VIEW_FAILURE";

const LIST_GLOBAL_SEARCH_REQUEST = "LIST_GLOBAL_SEARCH_REQUEST";
const LIST_GLOBAL_SEARCH_SUCCESS = "LIST_GLOBAL_SEARCH_SUCCESS";

const GET_METACONFIG_REQUEST = "GET_METACONFIG_REQUEST";
const GET_METACONFIG_SUCCESS = "GET_METACONFIG_SUCCESS";
const GET_METACONFIG_FAILURE = "GET_METACONFIG_FAILURE";
const TOGGLE_THEME = "TOGGLE_THEME";
const UPDATE_BASE_URL = "UPDATE_BASE_URL";

const GET_CURRENTUSER_REQUEST = "GET_CURRENTUSER_REQUEST";
const GET_CURRENTUSER_SUCCESS = "GET_CURRENTUSER_SUCCESS";
const GET_CURRENTUSER_FAILURE = "GET_CURRENTUSER_FAILURE";

const SET_SELECTED_MODULE = "SET_SELECTED_MODULE";

const RESET_STORE = "RESET_STORE";

const EDIT_VIEW_REQUEST = "EDIT_VIEW_REQUEST";
const EDIT_VIEW_SUCCESS = "EDIT_VIEW_SUCCESS";
const EDIT_VIEW_FAILURE = "EDIT_VIEW_FAILURE";

const EDIT_INOUTBOUNDEMAIL_REQUEST = "EDIT_INOUTBOUNDEMAIL_REQUEST";
const EDIT_INOUTBOUNDEMAIL_SUCCESS = "EDIT_INOUTBOUNDEMAIL_SUCCESS";
const EDIT_INOUTBOUNDEMAIL_FAILURE = "EDIT_INOUTBOUNDEMAIL_FAILURE";

const SUBMIT_EDIT_VIEW_REQUEST = "SUBMIT_EDIT_VIEW_REQUEST";
const SUBMIT_EDIT_VIEW_SUCCESS = "SUBMIT_EDIT_VIEW_SUCCESS";
const SUBMIT_EDIT_VIEW_FAILURE = "SUBMIT_EDIT_VIEW_FAILURE";

const DETAIL_VIEW_REQUEST = "DETAIL_VIEW_REQUEST";
const DETAIL_VIEW_FILTER_REQUEST = "DETAIL_VIEW_FILTER_REQUEST";
const DETAIL_VIEW_SUCCESS = "DETAIL_VIEW_SUCCESS";
const DETAIL_VIEW_FILTER_SUCCESS = "DETAIL_VIEW_FILTER_SUCCESS";
const DETAIL_VIEW_FAILURE = "DETAIL_VIEW_FAILURE";

// Report Detail View
const DETAIL_GROUP_VIEW_SUCCESS = "DETAIL_GROUP_VIEW_SUCCESS";
const DETAIL_GROUP_VIEW_REQUEST = "DETAIL_GROUP_VIEW_REQUEST";
const REPORT_DETAIL_VIEW_FILTER_REQUEST = "REPORT_DETAIL_VIEW_FILTER_REQUEST";
const REPORT_DETAIL_VIEW_FILTER_SUCCESS = "REPORT_DETAIL_VIEW_FILTER_SUCCESS";
const REPORT_DETAIL_VIEW_SUCCESS = "REPORT_DETAIL_VIEW_SUCCESS";
const REPORT_DETAIL_VIEW_REQUEST = "REPORT_DETAIL_VIEW_REQUEST";
const REPORT_DETAIL_VIEW_FAILURE = "REPORT_DETAIL_VIEW_FAILURE";

const SUBPANEL_LIST_VIEW_REQUEST = "SUBPANEL_LIST_VIEW_REQUEST";
const SUBPANEL_LIST_VIEW_SUCCESS = "SUBPANEL_LIST_VIEW_SUCCESS";
const SUBPANEL_LIST_VIEW_FAILURE = "SUBPANEL_LIST_VIEW_FAILURE";

const GET_COLUMNSCHOOSER_FIELDS_REQUEST = "GET_COLUMNSCHOOSER_FIELDS_REQUEST";
const GET_COLUMNSCHOOSER_FIELDS_SUCCESS = "GET_COLUMNSCHOOSER_FIELDS_SUCCESS";
const GET_COLUMNSCHOOSER_FIELDS_FAILURE = "GET_COLUMNSCHOOSER_FIELDS_FAILURE";

const GET_NOTIFICATIONS_REQUEST = "GET_NOTIFICATIONS_REQUEST";
const GET_NOTIFICATIONS_SUCCESS = "GET_NOTIFICATIONS_SUCCESS";
const GET_NOTIFICATIONS_FAILURE = "GET_NOTIFICATIONS_FAILURE";
const SWITCH_NOTIFICATIONS_LISTENER = "SWITCH_NOTIFICATIONS_LISTENER";
const MARK_NOTIFICATION_READ_SUCCESS = "MARK_NOTIFICATION_READ_SUCCESS";
const DASHLET_DIALOG_LINKS_REQUEST = "DASHLET_DIALOG_LINKS_REQUEST";
const DASHLET_DIALOG_LINKS_SUCCESS = "DASHLET_DIALOG_LINKS_SUCCESS";
const DASHLET_DIALOG_LINKS_FAILURE = "DASHLET_DIALOG_LINKS_FAILURE";

const REMOVEDASHLET_REQUEST = "REMOVEDASHLET_REQUEST";
const REMOVEDASHLET_SUCCESS = "REMOVEDASHLET_SUCCESS";
const REMOVEDASHLET_FAILURE = "REMOVEDASHLET_FAILURE";

const REMOVEDASHBOARD_SUCCESS = "REMOVEDASHBOARD_SUCCESS"; 

const SAVE_DASHLET_LAYOUT_REQUEST = "SAVE_DASHLET_LAYOUT_REQUEST";
const SAVE_DASHLET_LAYOUT_SUCCESS = "SAVE_DASHLET_LAYOUT_SUCCESS";
const SAVE_DASHLET_LAYOUT_FAILURE = "SAVE_DASHLET_LAYOUT_FAILURE";

const BPM_UPDATE_REQUEST = "BPM_UPDATE_REQUEST";
const BPM_UPDATE_SUCCESS = "BPM_UPDATE_SUCCESS";
const BPM_UPDATE_FAILURE = "BPM_UPDATE_FAILURE";

const MODULE_FIELD_TYPE_REQUEST = "MODULE_FIELD_TYPE_REQUEST";
const MODULE_FIELD_TYPE_SUCCESS = "MODULE_FIELD_TYPE_SUCCESS";
const MODULE_FIELD_TYPE_FAILURE = "MODULE_FIELD_TYPE_FAILURE";

//Email
const EMAIL_CREATE_VIEW_REQUEST = "EMAIL_CREATE_VIEW_REQUEST";
const EMAIL_CREATE_VIEW_SUCCESS = "EMAIL_CREATE_VIEW_SUCCESS";
const EMAIL_CREATE_VIEW_FAILURE = "EMAIL_CREATE_VIEW_FAILURE";

const SUBMIT_EMAIL_CREATE_VIEW_REQUEST = "SUBMIT_EMAIL_CREATE_VIEW_REQUEST";
const SUBMIT_EMAIL_CREATE_VIEW_SUCCESS = "SUBMIT_EMAIL_CREATE_VIEW_SUCCESS";
const SUBMIT_EMAIL_CREATE_VIEW_FAILURE = "SUBMIT_EMAIL_CREATE_VIEW_FAILURE";

const EMAIL_TEST_REQUEST="EMAIL_TEST_REQUEST";
const EMAIL_TEST_SUCCESS = "EMAIL_TEST_SUCCESS";
const EMAIL_TEST_FAILURE = "EMAIL_TEST_FAILURE";

const CALENDAR_LIST_VIEW_REQUEST = "CALENDAR_LIST_VIEW_REQUEST";
const CALENDAR_LIST_VIEW_SUCCESS = "CALENDAR_LIST_VIEW_SUCCESS";
const CALENDAR_LIST_VIEW_FAILURE = "CALENDAR_LIST_VIEW_FAILURE";

const SORT_ORDER = "SORT_ORDER";
const SORT_BY = "SORT_BY";

export {
	LOGIN_REQUEST,
	LOGIN_SUCCESS,
	LOGIN_FAILURE,
	CLEAR_LOGIN_ERROR,

	LOGO_REQUEST,
	LOGO_SUCCESS,
	LOGO_FAILURE,

	FORGOT_REQUEST,
	FORGOT_SUCCESS,
	FORGOT_FAILURE,

	LOGOUT_REQUEST,
	LOGOUT_SUCCESS,
	LOGOUT_FAILURE,
	FORCE_LOGOUT,

	RESET_REQUEST,
	RESET_SUCCESS,
	RESET_FAILURE,
	
	SIDEBAR_LINKS_REQUEST,
	SIDEBAR_LINKS_SUCCESS,
	SIDEBAR_LINKS_FAILURE,
	DASHBOARD_REQUEST,
	DASHBOARD_SUCCESS,
	DASHBOARD_FAILURE,
	GET_DASHLET_REQUEST,
	GET_DASHLET_SUCCESS,
	GET_DASHLET_FAILURE,
	ADD_DASHLET_REQUEST,
	ADD_DASHLET_SUCCESS,
	ADD_DASHLET_FAILURE,

	EDIT_DASHLET_REQUEST,
	EDIT_DASHLET_SUCCESS,
	EDIT_DASHLET_FAILURE,

	CONFIGURE_DASHLET_REQUEST,
	CONFIGURE_DASHLET_SUCCESS,
	CONFIGURE_DASHLET_FAILURE,

	STORE_STATE_REQUEST,
	STORE_STATE_SUCCESS,
	STORE_STATE_FAILURE,

	ADD_DASHBOARD_REQUEST,
	ADD_DASHBOARD_SUCCESS,
	ADD_DASHBOARD_FAILURE,

	USER_PREFERENCE_REQUEST,
	USER_PREFERENCE_SUCCESS,
	USER_PREFERENCE_FAILURE,
	LIST_VIEW_REQUEST,
	LIST_VIEW_SUCCESS,
	LIST_VIEW_FAILURE,
	LIST_GLOBAL_SEARCH_REQUEST,
	LIST_GLOBAL_SEARCH_SUCCESS,
	FILTER_CONFIG_REQUEST,
	FILTER_CONFIG_SUCCESS,
	FILTER_CONFIG_FAILURE,
	GET_METACONFIG_REQUEST,
	GET_METACONFIG_SUCCESS,
	GET_METACONFIG_FAILURE,
	TOGGLE_THEME,
	GET_CURRENTUSER_REQUEST,
	GET_CURRENTUSER_SUCCESS,
	GET_CURRENTUSER_FAILURE,
	SET_SELECTED_MODULE,
	RESET_STORE,
	EDIT_VIEW_REQUEST,
	EDIT_VIEW_SUCCESS,
	EDIT_VIEW_FAILURE,
	SUBMIT_EDIT_VIEW_REQUEST,
	SUBMIT_EDIT_VIEW_SUCCESS,
	SUBMIT_EDIT_VIEW_FAILURE,

	DETAIL_VIEW_REQUEST,
	DETAIL_VIEW_FILTER_REQUEST,
	DETAIL_GROUP_VIEW_REQUEST,
	REPORT_DETAIL_VIEW_REQUEST,
	REPORT_DETAIL_VIEW_FILTER_SUCCESS,
	REPORT_DETAIL_VIEW_FILTER_REQUEST,
	REPORT_DETAIL_VIEW_SUCCESS,
	REPORT_DETAIL_VIEW_FAILURE,
	DETAIL_VIEW_SUCCESS,
	DETAIL_GROUP_VIEW_SUCCESS,
	DETAIL_VIEW_FILTER_SUCCESS,
	DETAIL_VIEW_FAILURE,
	SUBPANEL_LIST_VIEW_REQUEST,
	SUBPANEL_LIST_VIEW_SUCCESS,
	SUBPANEL_LIST_VIEW_FAILURE,
	UPDATE_BASE_URL,
	GET_COLUMNSCHOOSER_FIELDS_SUCCESS,
	GET_COLUMNSCHOOSER_FIELDS_FAILURE,
	GET_COLUMNSCHOOSER_FIELDS_REQUEST,
	GET_NOTIFICATIONS_FAILURE,
	GET_NOTIFICATIONS_REQUEST,
	GET_NOTIFICATIONS_SUCCESS,
	SWITCH_NOTIFICATIONS_LISTENER,
	MARK_NOTIFICATION_READ_SUCCESS,
	DASHLET_DIALOG_LINKS_REQUEST,
	DASHLET_DIALOG_LINKS_SUCCESS,
	DASHLET_DIALOG_LINKS_FAILURE,
	REMOVEDASHLET_REQUEST,
	REMOVEDASHLET_SUCCESS,
	REMOVEDASHLET_FAILURE,
	REMOVEDASHBOARD_SUCCESS,
	SAVE_DASHLET_LAYOUT_REQUEST,
	SAVE_DASHLET_LAYOUT_SUCCESS,
	SAVE_DASHLET_LAYOUT_FAILURE,

	BPM_UPDATE_REQUEST,
	BPM_UPDATE_SUCCESS,
	BPM_UPDATE_FAILURE,

	MODULE_FIELD_TYPE_REQUEST,
	MODULE_FIELD_TYPE_SUCCESS,
	MODULE_FIELD_TYPE_FAILURE,

	EMAIL_CREATE_VIEW_REQUEST,
	EMAIL_CREATE_VIEW_SUCCESS,
	EMAIL_CREATE_VIEW_FAILURE,

	SUBMIT_EMAIL_CREATE_VIEW_REQUEST,
	SUBMIT_EMAIL_CREATE_VIEW_SUCCESS,
	SUBMIT_EMAIL_CREATE_VIEW_FAILURE,

	EMAIL_TEST_REQUEST,
	EMAIL_TEST_SUCCESS,
	EMAIL_TEST_FAILURE,
	CALENDAR_LIST_VIEW_REQUEST,
	CALENDAR_LIST_VIEW_SUCCESS,
	CALENDAR_LIST_VIEW_FAILURE,

	SORT_ORDER,
	SORT_BY,
	EDIT_INOUTBOUNDEMAIL_REQUEST,
	EDIT_INOUTBOUNDEMAIL_SUCCESS,
	EDIT_INOUTBOUNDEMAIL_FAILURE


};
